<h2 mat-dialog-title>Whatsapp</h2>
<p class="sub-title">Número com DDI DDD, e.g: 55 11 95555-8888</p>
<!-- Exempli gratia -->
<form [formGroup]="itemForm" (ngSubmit)="submit()">
  <mat-dialog-content>
    <input
      type="text"
      inputmode="numeric"
      style="
        background-color: rgb(255, 255, 255);
        color: #4396a2;
        font-weight: bold;
      "
      name="whatsapp"
      ngInput
      placeholder="DDI DD NNNNN-NNNN"
      [textMask]="{ mask: cpfcnpjmask }"
      (input)="catchEntry(itemForm.controls['whatsapp'].value)"
      [formControl]="itemForm.controls['whatsapp']"
    />
  </mat-dialog-content>
  <mat-dialog-actions>
    <span fxFlex></span>
    <button mat-button mat-dialog-close>Cancelar</button>
    <button
      type="submit"
      mat-raised-button
      mat-dialog-close
      color="primary2"
      [disabled]="itemForm.disabled || !valid"
    >
      OK
    </button>
  </mat-dialog-actions>
</form>
